import { Routes, Route, Navigate } from 'react-router-dom'
import Home from 'views/join/home'
import Form from 'views/join/form'
import Verify from 'views/join/verify'
import Password from 'views/join/password'
import Agreement from 'views/join/agreement'
import Email from 'views/join/email'
import Success from 'views/join/success'
import DataCertificate from 'views/dataCertificate'
import Certificate from 'views/dataCertificate/Certificate'

const Join = () => {
	return (
		<Routes>
			<Route path="/dataCertificate" element={<DataCertificate />} /> {/* 데이터 증명서 비번입력 */}
			<Route path="/certificate" element={<Certificate />} />         {/* 데이터 증명서 */}
			<Route path="/" element={<Home />} />							{/* 인트로 */}
			<Route path="agreement" element={<Agreement />} />				{/* 약관동의 */}
			<Route path="form" element={<Form />} />						{/* 가입 폼 */}
			<Route path="verify" element={<Verify />} />					{/* 인증번호 입력 */}
			<Route path="email" element={<Email />} />						{/* 이메일 기입 */}
			<Route path="password" element={<Password />} />				{/* 비번 설정 */}
			<Route path="success" element={<Success />} />					{/* 가입 성공 */}
			<Route path="*" element={<Navigate replace to="/" />} />		{/* 그외 */}
		</Routes>
	)
}

export default Join